<template>
  <div
    class="svg-image"
    v-html="svgContent"
  />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  svg: { type: String, required: true },
  color: { type: String, default: 'currentColor' },
  width: { type: [Number, String], default: null },
  height: { type: [Number, String], default: null }
})

const svgContent = computed(() => {
  let svg = props.svg

  svg = svg.replace(/fill=".*?"/g, `fill="${props.color}"`)
  svg = svg.replace(/stroke=".*?"/g, `stroke="${props.color}"`)

  if (props.width) {
    const widthVal = typeof props.width === 'number' ? `${props.width}px` : props.width
    svg = svg.replace(/<svg([^>]*?)width=".*?"/, `<svg$1width="${widthVal}"`)
  }

  if (props.height) {
    const heightVal = typeof props.height === 'number' ? `${props.height}px` : props.height
    svg = svg.replace(/<svg([^>]*?)height=".*?"/, `<svg$1height="${heightVal}"`)
  }

  return svg
})
</script>

<style scoped>
.svg-image {
  display: inline-block;
  line-height: 0;
  vertical-align: middle;
}
</style>
